import { render } from "./GenproxLink.vue?vue&type=template&id=ade6a438&scoped=true&ts=true"
import script from "./GenproxLink.vue?vue&type=script&lang=ts"
export * from "./GenproxLink.vue?vue&type=script&lang=ts"

import "./GenproxLink.vue?vue&type=style&index=0&id=ade6a438&lang=postcss&scoped=true"
/* custom blocks */
import block0 from "./GenproxLink.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade6a438"]])

export default __exports__